class LasiriusFlowRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-flow-track]');
    this.panels = [...this.querySelectorAll('[data-flow-panel]')];
    this.previousButton = this.querySelector('[data-flow-previous]');
    this.nextButton = this.querySelector('[data-flow-next]');
    this.position = this.querySelector('[data-flow-position]');
    this.activeName = this.querySelector('[data-flow-active-name]');
    this.progress = this.querySelector('[data-flow-progress]');

    if (!this.track || this.panels.length === 0) return;

    this.activeIndex = 0;
    this.frame = null;
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.previousButton?.addEventListener('click', () => this.move(-1));
    this.nextButton?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
    this.track.addEventListener('keydown', (event) => this.handleKeydown(event));
    window.addEventListener('resize', () => this.requestUpdate(), { passive: true });

    this.update(0);
  }

  disconnectedCallback() {
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  handleKeydown(event) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(event.key)) return;

    event.preventDefault();
    if (event.key === 'Home') this.goTo(0);
    if (event.key === 'End') this.goTo(this.panels.length - 1);
    if (event.key === 'ArrowLeft') this.move(-1);
    if (event.key === 'ArrowRight') this.move(1);
  }

  move(direction) {
    this.goTo(Math.min(this.panels.length - 1, Math.max(0, this.activeIndex + direction)));
  }

  goTo(index) {
    const panel = this.panels[index];
    if (!panel) return;

    panel.scrollIntoView({
      behavior: this.motionQuery.matches ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'start'
    });
    this.update(index);
  }

  requestUpdate() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      const trackLeft = this.track.getBoundingClientRect().left;
      const index = this.panels.reduce((nearest, panel, panelIndex) => {
        const distance = Math.abs(panel.getBoundingClientRect().left - trackLeft);
        return distance < nearest.distance ? { index: panelIndex, distance } : nearest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
      this.update(index);
    });
  }

  update(index) {
    this.activeIndex = index;
    const total = this.panels.length;
    const activePanel = this.panels[index];

    this.panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;
      panel.toggleAttribute('data-active', active);
      panel.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (this.position) this.position.textContent = `${index + 1} / ${total}`;
    if (this.activeName) this.activeName.textContent = activePanel?.dataset.flowName || '';
    if (this.progress) this.progress.style.setProperty('--flow-progress', `${((index + 1) / total) * 100}%`);
    if (this.previousButton) this.previousButton.disabled = index === 0;
    if (this.nextButton) this.nextButton.disabled = index === total - 1;
  }
}

if (!customElements.get('lasirius-flow-rail')) {
  customElements.define('lasirius-flow-rail', LasiriusFlowRail);
}
